module.exports = __webpack_public_path__ + "71040122141e2f77dff34e03c32af256.MP3";